import React from 'react';
import { TextField, InputAdornment, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/*
Search Bar Component
--------------------
Search input for filtering blog posts
*/

function SearchBar({ searchQuery, onSearchChange }) {
  const theme = useTheme();

  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Search the blog..."
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{
              color: theme.palette.text.primary,
              opacity: 0.4
            }} />
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: theme.palette.mode === 'dark'
            ? `${theme.palette.primary.main}0D` // main color at 5% opacity
            : `${theme.palette.primary.main}08`, // main color at 3% opacity
          borderRadius: '8px',
          fontFamily: 'Montserrat',
          fontSize: { xs: '0.875rem', sm: '1rem' },
          '& fieldset': {
            borderColor: theme.palette.mode === 'dark'
              ? `${theme.palette.primary.main}33` // main color at 20% opacity
              : `${theme.palette.primary.main}33`,
          },
          '&:hover fieldset': {
            borderColor: theme.palette.mode === 'dark'
              ? `${theme.palette.primary.main}4D` // main color at 30% opacity
              : `${theme.palette.primary.main}4D`,
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.text.link,
          },
        },
        '& .MuiOutlinedInput-input': {
          color: theme.palette.text.primary,
          '&::placeholder': {
            color: theme.palette.text.primary,
            opacity: 0.5,
          },
        },
      }}
    />
  );
}

export default SearchBar;
